// extracted by mini-css-extract-plugin
export default {"errorText":"_T5UPThoBkfFyLCdhm9Q"};